const organizationLogos = [
  {
    name: "The Co-operators",
    src: "/images/corp logos/cooperators-logo-320.webp",
    width: 560,
    height: 180,
    sizes: "160px",
  },
  {
    name: "XE",
    src: "/images/corp logos/xe-logo-320.webp",
    width: 900,
    height: 500,
    sizes: "160px",
  },
  {
    name: "Brookfield Asset Management",
    src: "/images/corp logos/Brookfield_Asset_Management_logo.svg",
    width: 300,
    height: 45,
    sizes: "160px",
  },
  {
    name: "Euronet Worldwide",
    src: "/images/corp logos/euronet-logo-320.webp",
    width: 330,
    height: 62,
    sizes: "160px",
  },
  {
    name: "Ria Money Transfer",
    src: "/images/corp logos/Ria_logo.svg",
    width: 145,
    height: 67,
    sizes: "160px",
  },
  {
    name: "Mazda",
    src: "/images/corp logos/Mazda_logo.svg",
    width: 850,
    height: 144,
    sizes: "160px",
  },
  {
    name: "Royal LePage",
    src: "/images/corp logos/royal-lepage-logo-320.webp",
    width: 680,
    height: 680,
    sizes: "160px",
  },
  {
    name: "Xerox",
    src: "/images/corp logos/Xerox-Logo.svg",
    width: 1200,
    height: 800,
    sizes: "160px",
  },
];

export default organizationLogos;
